import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../utils/api';

const TYPE_COLORS = { '秩序巡逻': '#1890ff', '工程巡检': '#fa8c16', '管家巡检': '#52c41a' };

export default function InspectList({ user }) {
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState({ type: '' });

  const canAdd = ['admin','manager','security','engineer','steward'].includes(user.role);

  const fetch = async () => {
    setLoading(true);
    try {
      const params = {};
      if (filter.type) params.type = filter.type;
      const res = await API.get('/inspections', { params });
      setList(res.data);
    } catch (err) { alert('获取失败'); }
    finally { setLoading(false); }
  };

  useEffect(() => { fetch(); }, [filter.type]);

  const getLocation = (r) => {
    if (r.location_type === '楼幢') return r.building;
    if (r.location_type === '自定义') return r.custom_location;
    return r.location_type;
  };

  const anomalies = (r) => {
    const keys = ['drain','basement_water','safety','hygiene','items','lights','parking'];
    const labels = { drain:'排水', basement_water:'车库积水', safety:'安全隐患', hygiene:'卫生', items:'物品整齐', lights:'灯光', parking:'车辆停放' };
    const bad = keys.filter(k => r[k+'_ok'] === 0).map(k => labels[k]);
    const customBad = (r.custom_items || []).filter(i => i.is_ok === 0).map(i => i.item_name);
    return [...bad, ...customBad];
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h1 style={styles.headerTitle}>巡检记录</h1>
        {canAdd && (
          <button style={styles.addBtn} onClick={() => navigate('/inspect/add')}>+ 新增</button>
        )}
      </div>

      <div style={styles.filterBar}>
        {['','秩序巡逻','工程巡检','管家巡检'].map(t => (
          <button key={t}
            style={{...styles.filterBtn, ...(filter.type===t ? styles.filterBtnActive : {})}}
            onClick={() => setFilter({...filter, type: t})}>
            {t || '全部'}
          </button>
        ))}
      </div>

      <div style={styles.list}>
        {loading ? <div style={styles.loading}>加载中...</div>
          : list.length === 0 ? <div style={styles.empty}>暂无记录</div>
          : list.map(r => {
            const bad = anomalies(r);
            return (
              <div key={r.id} style={{...styles.card, borderLeftColor: TYPE_COLORS[r.type]}}
                onClick={() => navigate(`/inspect/${r.id}`)}>
                <div style={styles.cardTop}>
                  <span style={{...styles.typeBadge, background: TYPE_COLORS[r.type]}}>{r.type}</span>
                  {bad.length > 0
                    ? <span style={styles.badBadge}>⚠️ {bad.length}项异常</span>
                    : <span style={styles.okBadge}>✅ 全部正常</span>}
                </div>
                <div style={styles.cardInfo}>
                  <span>📍 {getLocation(r)}</span>
                  <span>🕐 {new Date(r.inspect_time).toLocaleString('zh-CN',{month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit'})}</span>
                </div>
                {bad.length > 0 && (
                  <div style={styles.badList}>{bad.map((b,i) => <span key={i} style={styles.badTag}>{b}</span>)}</div>
                )}
                <div style={styles.cardFooter}>{r.creator_name}</div>
              </div>
            );
          })}
      </div>
    </div>
  );
}

const styles = {
  container: { minHeight: '100vh', background: '#f5f7fa', paddingBottom: '20px' },
  header: {
    background: 'linear-gradient(90deg, #1a6a3a, #2d9d5a)',
    padding: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    position: 'sticky', top: 0, zIndex: 100
  },
  headerTitle: { color: '#fff', margin: 0, fontSize: '18px', fontWeight: 700 },
  addBtn: { background: '#fff', color: '#1a6a3a', border: 'none', borderRadius: '20px', padding: '8px 18px', fontSize: '15px', fontWeight: 600, cursor: 'pointer' },
  filterBar: { display: 'flex', gap: '8px', padding: '12px 16px', overflowX: 'auto' },
  filterBtn: { padding: '6px 16px', border: '1.5px solid #e0e0e0', borderRadius: '16px', background: '#fff', fontSize: '13px', cursor: 'pointer', whiteSpace: 'nowrap' },
  filterBtnActive: { background: '#1a6a3a', color: '#fff', borderColor: '#1a6a3a' },
  list: { padding: '0 16px' },
  loading: { textAlign: 'center', padding: '40px', color: '#888' },
  empty: { textAlign: 'center', padding: '60px', color: '#bbb' },
  card: { background: '#fff', borderRadius: '12px', padding: '14px', marginBottom: '10px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', borderLeft: '4px solid #ccc', cursor: 'pointer' },
  cardTop: { display: 'flex', gap: '8px', marginBottom: '8px', alignItems: 'center' },
  typeBadge: { color: '#fff', borderRadius: '4px', padding: '2px 8px', fontSize: '12px', fontWeight: 600 },
  okBadge: { color: '#52c41a', fontSize: '13px' },
  badBadge: { color: '#ff4d4f', fontSize: '13px', fontWeight: 600 },
  cardInfo: { display: 'flex', gap: '16px', fontSize: '13px', color: '#666', marginBottom: '6px' },
  badList: { display: 'flex', flexWrap: 'wrap', gap: '4px', marginBottom: '6px' },
  badTag: { background: '#fff1f0', color: '#ff4d4f', border: '1px solid #ffccc7', borderRadius: '4px', padding: '1px 6px', fontSize: '12px' },
  cardFooter: { fontSize: '12px', color: '#999' }
};
